// GW 監査ユーザー棚卸し API クライアント。GET /gw/users/active → GwActiveUserDto[]。
// ApiClient に認証・エラー正規化を委譲。backend GwActiveUser に対応する DTO。
// SF user-reconcile-api.ts のミラー（GW 用の最小 DTO・/gw）。
import type { ApiClient } from "../api/client";

export interface UserReconcileApiDeps {
  readonly apiClient: ApiClient;
}

export interface GwActiveUserDto {
  readonly email: string;
  readonly lastLoginTime: string;
}

interface ActiveUsersResponse {
  readonly users: GwActiveUserDto[];
}

// GET /gw/users/active → GwActiveUserDto[]（GW のアクティブユーザー一覧）
export async function fetchActiveUsers(deps: UserReconcileApiDeps): Promise<GwActiveUserDto[]> {
  const resp = await deps.apiClient.get<ActiveUsersResponse>("/gw/users/active");
  return resp.users;
}
